export const BYD_BEARER_TOKEN = 'Bearer';
